import { render, staticRenderFns } from "./ModifyDnsRecordModal.vue?vue&type=template&id=f3e3d764&"
import script from "./ModifyDnsRecordModal.vue?vue&type=script&lang=js&"
export * from "./ModifyDnsRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports